import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 20"
      className="design-iconfont"
    >
      <path d="m7.877 14.457 2.026 1.533v-4.553c0-.166.042-.329.12-.475L14.323 3H3.643l4.122 7.978c.074.142.112.3.112.459v3.02ZM10.903 19a.994.994 0 0 1-.603-.203l-4.026-3.045a1 1 0 0 1-.397-.797v-3.274L1.112 2.459A1 1 0 0 1 2 1h14a1 1 0 0 1 .88 1.475l-4.977 9.215V18a1 1 0 0 1-1 1Z" />
    </svg>
  )
}
const FilterIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
FilterIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: '#fff',
}
// 参数类型
FilterIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
}

export default FilterIcon
